import { useState } from 'react';
import { Card, Text, Icon, Button, FlexBox } from '@ui5/webcomponents-react';
import '@ui5/webcomponents-icons/dist/AllIcons.js';

interface PageIntroProps {
  title: string;
  text: string;
  learnMore?: string;
  /** Storage key to remember dismissal */
  storageKey: string;
}

/**
 * PageIntro — Erklärungsbox am Anfang jeder Seite.
 * Kann vom Benutzer ausgeblendet werden (wird im localStorage gespeichert).
 * Jederzeit über einen Button wieder eingeblendet.
 */
export default function PageIntro({ title, text, learnMore, storageKey }: PageIntroProps) {
  const dismissKey = `help_dismissed_${storageKey}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(dismissKey) === 'true');

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(dismissKey, 'true');
  };

  const handleShow = () => {
    setDismissed(false);
    localStorage.removeItem(dismissKey);
  };

  if (dismissed) {
    return (
      <div style={{ marginBottom: '0.5rem', textAlign: 'right' }}>
        <Button
          icon="sys-help"
          design="Transparent"
          onClick={handleShow}
          tooltip="Hilfe einblenden"
          style={{ fontSize: '0.75rem', opacity: 0.6 }}
        >
          Hilfe anzeigen
        </Button>
      </div>
    );
  }

  return (
    <Card style={{ marginBottom: '1rem', borderLeft: '4px solid var(--sapInformativeColor, #0070f2)' }}>
      <div style={{ padding: '1rem 1.25rem' }}>
        <FlexBox justifyContent="SpaceBetween" alignItems="Start">
          <FlexBox alignItems="Start" style={{ gap: '0.75rem', flex: 1 }}>
            <Icon
              name="sys-help-2"
              style={{
                fontSize: '1.5rem',
                color: 'var(--sapInformativeColor, #0070f2)',
                flexShrink: 0,
                marginTop: '0.125rem'
              }}
            />
            <div>
              <Text style={{ fontWeight: '700', fontSize: '0.875rem', display: 'block', marginBottom: '0.375rem', color: 'var(--sapInformativeColor, #0070f2)' }}>
                {title}
              </Text>
              <Text style={{ fontSize: '0.8125rem', display: 'block', lineHeight: '1.6', color: 'var(--sapTextColor)' }}>
                {text}
              </Text>
              {learnMore && (
                <Text style={{ fontSize: '0.8125rem', display: 'block', marginTop: '0.5rem', color: 'var(--sapPositiveTextColor, #107e3e)', fontStyle: 'italic' }}>
                  {learnMore}
                </Text>
              )}
            </div>
          </FlexBox>
          <Button
            icon="decline"
            design="Transparent"
            onClick={handleDismiss}
            tooltip="Hilfe ausblenden"
            style={{ flexShrink: 0, marginLeft: '0.5rem' }}
          />
        </FlexBox>
      </div>
    </Card>
  );
}
